export default "__VITE_ASSET__4PkzSR3h__"